/**
 * Qud-specific sprite constants
 *
 * Caves of Qud uses 16x24 pixel tiles in its sprite atlases.
 */

/** Width of a Qud sprite cell in pixels */
export const CELL_WIDTH = 16;

/** Height of a Qud sprite cell in pixels */
export const CELL_HEIGHT = 24;
